module.exports = __webpack_public_path__ + "74ce1c6551a88a5b808080e5b0b206c1.png";